import React from 'react';

const DiamondPointIcon: React.FC = ({width}: any) => (
    <svg
        width={width}
        height={width}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 10.9989L10.9994 -0.000481856L22 11.0001L11.0006 21.9995L0 10.9989Z"
            fill="currentColor"
        />
    </svg>
);

export default DiamondPointIcon;
